import Vue from 'vue'
import Vuex from 'vuex'
import store_editor from './store_editor'
import editor_backup from './editor_backup'

Vue.use(Vuex)

const api_version = "1.1"
const client_version = "1.1.16.3"

export default new Vuex.Store({
  state: {
    debug: false,
    debug_source_ip: false,
    user: null,
    enable_options: [],
    access_token: null,
    session_state: null,
    auth: null,
    notifications: [],
    snackbar: [],
    api_endpoint: window.location.protocol + "//" + window.location.host + "/v" + api_version + "/api",
    langs: require('../lang/langs.json'),
    api_version: api_version,
    client_version: client_version,
    domain: "the-reading",
    fields: null,
    preference: null,
    http_log: [],
    rozetta_idp: null,
    side_menu: null,
    idps: {},
    lang_pairs: {
      all: {}
    },
    web_socket: {},
    web_socket_access: false,
    web_socket_log: [],
    main_height: 0
  },
  getters: {
    debug: state => {
      return state.debug;
    },
    debug_source_ip: state => {
      return state.debug_source_ip;
    },
    enable_options: state => {
      return state.enable_options;
    },
    user: state => {
      return state.user;
    },
    access_token: state => {
      return state.access_token;
    },
    session_state: state => {
      return state.session_state;
    },
    auth: state => {
      return state.auth;
    },
    notifications: state => {
      return state.notifications;
    },
    snackbar: state => {
      return state.snackbar;
    },
    api_endpoint: state => {
      return state.api_endpoint;
    },
    langs: state => {
      return state.langs;
    },
    api_version: state => {
      return state.api_version;
    },
    client_version: state => {
      return state.client_version;
    },
    domain: state => {
      return state.domain;
    },
    fields: state => {
      return state.fields;
    },
    preference: state => {
      return state.preference;
    },
    http_log: state => {
      return state.http_log;
    },
    rozetta_idp: state => {
      return state.rozetta_idp;
    },
    side_menu: state => {
      return state.side_menu;
    },
    idps: state => {
      return state.idps;
    },
    lang_pairs: state => {
      return state.lang_pairs;
    },
    web_socket: state => {
      return state.web_socket;
    },
    web_socket_log: state => {
      return state.web_socket_log;
    },
    web_socket_access: state => {
      return state.web_socket_access;
    },
    main_height: state => {
      return state.main_height;
    }
  },
  mutations: {
    setUser(state, user){
      state.user = user;
    },
    setEnableOptions(state, enable_options){
      state.enable_options = enable_options;
    },
    setAccessToken(state, access_token){
      if(state.debug){
        console.log("setAccessToken: " + access_token);
      }
      state.access_token = access_token;
    },
    setSessionState(state, session_state){
      if(state.debug){
        console.log("setSessionState: " + session_state);
      }
      state.session_state = session_state;
    },
    setAuth(state, auth){
      state.auth = auth;
    },
    setNotification(state, data){
      if(data.type === "debug"){
        if(!state.debug){
          return;
        }
        data.type = "grey";
      }
      if(typeof data.message !== 'string'){
        // eidあり。種別に応じて振り直し
        switch(data.message.eid[4]){
          case "0":
            // 成功
            data.type = "success";
            break;
          case "1":
            // ユーザリトライ可能
            data.type = "warning";
            break;
          default:
            // それ以外
            data.type = "error";
            break;
        }
      }
      if(data.type === "success" && state.preference){
        if((!state.preference.notify_success)){
          // 成功時は表示しない
          return;
        }
      }
      state.notifications.unshift({
        type: data.type,
        message: data.message,
        date: new Date(),
        route: data.route
      });
      if(state.preference
        && state.preference.notify_limit !== -1
        && state.notifications.length > state.preference.notify_limit){
        while(state.notifications.length > state.preference.notify_limit){
          state.notifications.pop();
        }
      }
      state.snackbar = state.snackbar.concat([data]);
    },
    deleteNotification(state, index){
      if(state.notifications[index]){
        state.notifications.splice(index, 1);
      }
    },
    setDomain(state, domain){
      state.domain = domain;
    },
    setFields(state, fields){
      state.fields = fields;
    },
    setPreference(state, preference){
      state.preference = preference;
    },
    setHttpLog(state, data){
      state.http_log.unshift(data);
      var http_log_limit = 10;
      if(state.preference != null
        && state.preference.http_log_limit != null){
        http_log_limit = state.preference.http_log_limit;
      }
      while(state.http_log.length > http_log_limit){
        state.http_log.pop();
      }
    },
    setRozettaIdp(state, rozetta_idp){
      state.rozetta_idp = rozetta_idp;
    },
    setSideMenu(state, side_menu){
      state.side_menu = side_menu;
    },
    setIdps(state, idps){
      state.idps = idps;
    },
    setLangPairs(state, lang_pairs){
      state.lang_pairs = lang_pairs;
    },
    setWebSocket(state, data){
      if(state.debug){
        console.log("setWebSocket:" + data.namespace);
      }
      var web_socket = Object.assign({}, state.web_socket);
      web_socket[data.namespace] = data.socket;
      state.web_socket = web_socket;
    },
    deleteWebSocket(state, namespace){
      if(namespace in state.web_socket){
        if(state.debug){
          console.log("deleteWebSocket:" + namespace);
        }
        var web_socket = Object.assign({}, state.web_socket);
        delete web_socket[namespace];
        state.web_socket = web_socket;
      }
    },
    setWebSocketLog(state, data){
      state.web_socket_log.unshift(data);
      var web_socket_log_limit = 30;
      if(state.preference != null
        && state.preference.web_socket_log_limit != null){
        web_socket_log_limit = state.preference.web_socket_log_limit;
      }
      while(state.web_socket_log.length > web_socket_log_limit){
        state.web_socket_log.pop();
      }
      state.web_socket_access = true;
      setTimeout(function(){
        this.web_socket_access = false
      }.bind(state), 50);
    },
    setMainHeight(state, main_height){
      state.main_height = main_height;
    }
  },
  actions: {

  },
  modules: {
    editor: store_editor
  },
  plugins: [editor_backup]
})
